import { AnyAction, combineReducers, Reducer } from 'redux';
import { pageLayoutReducer, PageLayoutState } from './layout';
import { authReducer } from './auth';
import { assignmentReducer, AssignmentState } from './assignment';
import { submissionReducer } from './submission';
import { sidebarReducer } from './sidebar';
import { FormPreviewPageState, formPreviewReducer } from './form-preview';
import { spaceObjectsReducer, SpacePageState } from './space';
import { AssignmentReviewPageState, assignmentReviewReducer } from './assignment-review';
import { toastReducer, ToastState } from './toast';
import { SubmissionPreviewPageState, submissionPreviewReducer } from './submission-preview';
import { reportReducer, ReportState } from './report';
import { gradingSubmissionReducer } from './grading-submission';
import { FormEditPageState, formEditReducer } from './form-edit';
import { GradingSubmissionState } from './grading-submission/grading-submission.states';
import { ExplorePageState, exploreReducer } from './explore';
import { FormCategoriesGlobalState, formCategoriesGlobalReducer } from './form-categories-global';
import { formNextjsAppReducer, FormNextjsAppReducerState } from '@module/form-nextjs-app';
import { aiChatAppReducer, AIChatAppReducerState } from '@module/ai-chat-app';
import { fileStorageReducer } from '@module/file-management-app';
import { assignmentCreationReducer } from '../containers/form-edit/redux/assignment-creation/assignment-creation.reducer';
import { AssignmentCreationPageState } from '../containers/form-edit/redux/assignment-creation/assignment-creation.state';
import { classesReducer, ClassesState } from './classes/classes.reducer';
import {
  classStudentDetailReducer,
  ClassStudentDetailState,
} from './classes/class-student.reducer';

export type RootReducerState = {
  //Todo: Refactor type for each reducer has any type
  auth: any;
  pageLayout: PageLayoutState;
  toast: ToastState;
  assignment: AssignmentState;
  submission: any;
  sidebar: any;
  spaceObjects: SpacePageState;
  formPreview: FormPreviewPageState;
  submissionPreviewPage: SubmissionPreviewPageState;
  assignmentReview: AssignmentReviewPageState;
  report: ReportState;
  gradingSubmission: GradingSubmissionState;
  formEdit: FormEditPageState;
  explore: ExplorePageState;
  formCategoriesGlobal: FormCategoriesGlobalState;
  formPreviewApp: FormNextjsAppReducerState;
  assignmentCreation: AssignmentCreationPageState;
  classes: ClassesState;
  classStudentDetail: ClassStudentDetailState;
} & AIChatAppReducerState;

const combinedReducer = combineReducers<RootReducerState>({
  auth: authReducer,
  pageLayout: pageLayoutReducer,
  toast: toastReducer,
  assignment: assignmentReducer,
  spaceObjects: spaceObjectsReducer,
  submission: submissionReducer,
  sidebar: sidebarReducer,
  formPreview: formPreviewReducer,
  submissionPreviewPage: submissionPreviewReducer,
  assignmentReview: assignmentReviewReducer,
  report: reportReducer,
  gradingSubmission: gradingSubmissionReducer,
  formEdit: formEditReducer,
  explore: exploreReducer,
  formCategoriesGlobal: formCategoriesGlobalReducer,
  formPreviewApp: formNextjsAppReducer,
  assignmentCreation: assignmentCreationReducer,
  classes: classesReducer,
  classStudentDetail: classStudentDetailReducer,
  aiChatApp: aiChatAppReducer,
  fileStorage: fileStorageReducer,
});

export const RESET_REDUX_STATE_ON_ROUTE_CHANGE = '@@app/RESET_REDUX_STATE_ON_ROUTE_CHANGE' as const;

export const resetReduxStateOnRouteChange = () =>
  ({ type: RESET_REDUX_STATE_ON_ROUTE_CHANGE }) as const;

export const rootReducer: Reducer<RootReducerState> = (state, action: AnyAction) => {
  if (action.type === RESET_REDUX_STATE_ON_ROUTE_CHANGE) {
    return combinedReducer(undefined, action);
  }
  return combinedReducer(state, action);
};
